// ─── src/components/ui/Badge.tsx ──────────────────────────────────────────────
import type { FC } from "react";

interface BadgeProps {
  label: string;
  className?: string;
}

export const Badge: FC<BadgeProps> = ({ label, className = "" }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full
                text-xs font-medium capitalize ${className}`}
  >
    {label}
  </span>
);
